import React from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { Carousel } from 'components';
import { injectIntl } from 'react-intl';
import layoutWithNavbar from 'layouts/withNavbar';
import './AboutInvestmentAdvice.scss';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCheck } from '@fortawesome/free-solid-svg-icons';

class AboutInvestmentAdvice extends React.Component {
  constructor(props) {
    super(props);
    this.slider1 = React.createRef();
    this.sllder2 = React.createRef();
  }

  render() {
    const { intl, currentLocale } = this.props;
    const stepTitle = [
      'aboutInvestmentAdvice.whoItsFor',
      'aboutInvestmentAdvice.howItWorkd',
      'aboutInvestmentAdvice.whatYouGet',
    ];
    const stepOne = [{
      title: 'aboutInvestmentAdvice.retailClients',
      desc: 'aboutInvestmentAdvice.1kInvestmentAssets',
    }, {
      title: 'aboutInvestmentAdvice.wealthClients',
      desc: 'aboutInvestmentAdvice.100kto500kInvestmentAssets',
    }, {
      title: 'aboutInvestmentAdvice.privateClients',
      desc: 'aboutInvestmentAdvice.over500kInvestmentAssets',
    }];
    // const stepThree = [
    //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    //   'Ut ex odio, ullamcorper in dolor non, consectetur porta ex.',
    //   'Integer nec vehicula felis. Curabitur commodo augue risus, in tristique est porttitor mattis.',
    //   'Aliquam consequat sodales elit, ac consequat turpis ullamcorper non.',
    // ];
    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
    };
    return (
      <div className="about_investment_advice">
        <Slider
          {...settings}
          beforeChange={(current, next) => { this.slider2.slickGoTo(next); }}
          ref={(slider) => { this.slider1 = slider; }}
          className="about_investment_advice__header"
        >
          {stepTitle.map((item, i) => (<h1 key={i}>{intl.formatMessage({ id: item })}</h1>))}
        </Slider>
        <Carousel
          className="about_investment_advice__step"
          isCenterMode
          beforeChange={(current, next) => { this.slider1.slickGoTo(next); }}
          fowardRef={(slider) => { this.slider2 = slider; }}
          withDots
        >
          {/* STEP 1 */}
          <div className="about_investment_advice__content">
            <h6>{intl.formatMessage({ id: 'aboutInvestmentAdvice.someGroupThatDesigned' })}</h6>
            {stepOne.map((item, i) => (
              <div key={i}>
                <h3>{intl.formatMessage({ id: item.title })}</h3>
                <p>{intl.formatMessage({ id: item.desc })}</p>
              </div>
            ))}
          </div>
          {/* STEP 2 */}
          <div className={`about_investment_advice__content--img ${currentLocale === 'AR' ? 'arabic' : ''}`} />
          {/* STEO 3 */}
          {/* <div className="about_investment_advice__content--second">
            {stepThree.map((item, i) => (
              <section key={i}>
                <FontAwesomeIcon icon={faCheck} />
                <p>{item}</p>
              </section>
            ))}
          </div> */}
        </Carousel>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentLocale: state.rootReducer.language.locale,
});

export default connect(mapStateToProps, null)(layoutWithNavbar(injectIntl(AboutInvestmentAdvice)));
